const t = {
  name: "TurnLeft",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.4144 4.00012H12C16.9723 4.00012 21 8.02784 21 13.0001C21 17.9724 16.9723 22.0001 12 22.0001C7.02772 22.0001 3 17.9724 3 13.0001H5C5 16.8678 8.13228 20.0001 12 20.0001C15.8677 20.0001 19 16.8678 19 13.0001C19 9.13241 15.8677 6.00012 12 6.00012H10.4143L12.4144 8.00015L11.0002 9.41436L6.58594 5.00015L11.0002 0.585938L12.4144 2.00015L10.4144 4.00012Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as TurnLeft
};
